import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { MAP__fields_by_id } from '@shared/types/types';
import { FIELD__base } from '../FIELD__base';
import { ENUM__field_graph_interaction } from '../_enums/ENUM__field_graph_interaction';

export function FN_FIELD__get_fields_map_with_graph_interaction(
  target: FIELD__base,
  interaction: ENUM__field_graph_interaction[],
  with_children: boolean,
): MAP__fields_by_id {
  let out: MAP__fields_by_id = new MAP__serializable();

  if (!interaction.includes(target.meta.graph__interaction)) return out;

  out.set(target.meta.field_id, target);

  if (!with_children) return out;

  let fields_children = target.fields__get_map(false).values();

  for (let field of fields_children.values()) {
    out.merge_with(FN_FIELD__get_fields_map_with_graph_interaction(field, interaction, true));
  }

  return out;
}
